import React from "react";
import { useLoading } from "./Loading";

const Privacy = () => {

    const { setLoading } = useLoading();
    setLoading(false);

    return (
        <div style={{ marginTop: "15px" }}>
            <h2 style={{marginBottom:"15px"}}>Privacy Policy for Pawtner</h2>
            <h6 style={{marginBottom:"15px"}}>PERSONAL DATA PROTECTION ACT 2010</h6>
            <div style={{display:"flex", flexDirection:"column", width:"90%", justifySelf:"center", alignContent:"center", textAlign:"justify"}}>
                <p>In compliance with the Personal Data Protection Act 2010 ("The Act") and its regulations, this informs you of your rights with regards to your personal data that has been and/ or will be, collected and processed by us.</p>
            <p>
                <strong>1. Introduction:</strong><br/>

                We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and share your personal information.
                </p>
                <p>
                <strong>2. Information Collection:</strong><br/>

                Personal Information: The personal data that you may provide include, but not limited to:-<br/>
                <li>Name</li>
                <li>NRIC no.</li>
                <li>Gender</li>
                <li>Email address</li>
                <li>Mobile phone no.</li>
                <li>Password</li>
                <li>Adoption preferences.</li>
                Pet Information: We collect information about pets listed for adoption, including photos, descriptions, and breed.
                Usage Information: We collect information about how you use the System, such as your IP address and browsing activity.
                </p>
                <p>
                <strong>3. Use of Information:</strong><br/>

                We use your information to: <br/>
                <li>Facilitate pet adoptions.<br/></li>
                <li>Communicate with you about pets and adoption processes.<br/></li>
                <li>Improve the System.<br/></li>
                <li>Comply with legal obligations.<br/><br/></li>
                We may share your information with:<br/>
                <li>Adopters and animal shelter.<br/></li>
                <li>Service providers who assist us with the System.<br/></li>
                <li>Law enforcement agencies when required.<br/></li>
                </p>
                <p>
                <strong>4. User Rights:</strong><br/>

                You have the right to:<br/>
                <li>Access your personal information.<br/></li>
                <li>Correct inaccuracies in your information.<br/></li>
                <li>Request deletion of your information.<br/></li>
                <li>Object to the processing of your information.<br/></li>
                To exercise these rights, please contact us at <a href="mailto:pawtner1234@gmail.com">pawtner1234@gmail.com</a>.
                </p>
                <p>
                <strong>5. Data Security:</strong><br/>

                We take reasonable measures to protect your information from unauthorized access and use.
                However, no security system is foolproof.
                </p>
                <p>
                <strong>6. Children's Privacy:</strong><br/>

                Our System is not intended for children under the age of 12.
                We do not knowingly collect information from children.
                </p>
                <p>
                <strong>7. Changes to Privacy Policy:</strong><br/>

                We may update this Privacy Policy from time to time. Users will be notified of changes via email or through the System.

                </p>
                <p>
                <strong>8. Contact Information:</strong><br/>

                For questions about this Privacy Policy, please contact us at <a href="mailto:pawtner1234@gmail.com">pawtner1234@gmail.com</a>.
            </p>
            </div>

        </div>
    )
};

export default Privacy;